import { hexToRgba as t } from "./convert.js";
var u = function u(r, e) {
    if (r === e) return !0;
    for (var o in r) if (r[o] !== e[o]) return !1;
    return !0;
  },
  a = function a(r, e) {
    return r.toLowerCase() === e.toLowerCase() ? !0 : u(t(r), t(e));
  };
export { u as equalColorObjects, a as equalHex };